/* eslint-disable max-len */
import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import PatientSubscriberInfo from '@components/pages/Claims/PatientSubscriberInfo/PatientSubscriberInfo.component'
import ProceduresInThisClaim from '@components/pages/Claims/ProceduresInThisClaim/ProceduresInThisClaim.component'
import ClaimDetails from '@components/pages/Claims/ClaimDetails/ClaimDetails.component'
import patientInfoData from '@components/pages/Claims/PatientSubscriberInfo/patientInfoData.json'
import proceduresData from '@components/pages/Claims/ProceduresInThisClaim/proceduresInThisClaim.json'
import claimDetailsData from '@components/pages/Claims/ClaimDetails/claimDetailsData.json'

function ClaimsInfo(): React.ReactElement {
  return (
    <>
      <Container fluid className="claimsInfoTable">
        <Row>
          <Col className="py-1">
            <Link to="/claims" className="p-0 me-1">
              <i className="bi bi-arrow-left-circle me-1"></i>Back To Claims
            </Link>
          </Col>
        </Row>
        <PatientSubscriberInfo {...patientInfoData} />
        <ProceduresInThisClaim procedures={proceduresData} />
        <ClaimDetails
          claimInfo={claimDetailsData.claimInfo}
          claimStatus={claimDetailsData.claimStatus}
          claimAmount={claimDetailsData.claimAmount}
          insurancePayment={claimDetailsData.insurancePayment}
        />
      </Container>
    </>
  )
}

export default ClaimsInfo
